import { useQuery } from '@tanstack/react-query'
import { InvoiceClientDto, OrderClientDto, TBookingInvoiceSearchOptions, TCustomInvoiceDto } from '../types'
import { defaultQueryOptions } from './common'
import { ClientInvoicesByPeriodService, ClientOrderSearchService } from '../services'
import { getServiceOptions, mapInvoiceToCustomInvoices, mapOrderToCustomInvoices } from '../mappers'

export const useClientBookingInvoices = (locationName: string, options: TBookingInvoiceSearchOptions) => {
  // Choose service dynamically based on sortColumn
  const service = options.sortColumn === 'serviceDates' ? ClientInvoicesByPeriodService : ClientOrderSearchService
  return useQuery<{ results: TCustomInvoiceDto[]; nextToken: string | null }>({
    queryKey: ['clientBookingInvoices', locationName, options, options.sortColumn],
    queryFn: async () => {
      const raw = await service.getData(locationName, getServiceOptions(options))

      // Normalize response to TCustomInvoiceDto[]
      const results =
        options.sortColumn === 'serviceDates'
          ? (raw.results as InvoiceClientDto[]).flatMap(mapInvoiceToCustomInvoices)
          : mapOrderToCustomInvoices(raw.results as OrderClientDto[])

      return {
        results,
        nextToken: raw.nextToken ?? null,
      }
    },
    ...defaultQueryOptions,
  })
}
